import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

import './notification-toast.scss';

export default class NotificationToast extends Component {
  get isError() {
    return this.args.content.type === 'error';
  }

  get isSuccess() {
    return this.args.content.type === 'success';
  }

  <template>
    <aside
      class="component-notification-toast
        {{if this.isError 'is-error'}}
        {{if this.isSuccess 'is-success'}}"
      ...attributes
    >

      <div class="_toast-content">
        <div class="_toast-header">
          {{svgJar
            @content.icon
            width="24px"
            class="_toast-icon"
            aria-hidden="true"
          }}
          <h5 class="_toast-headline" data-test-notification-headline>
            {{@content.headline}}
          </h5>
        </div>

        <p class="_toast-subhead" data-test-notification-message>
          {{@content.message}}
        </p>
      </div>
      <div class="_toast-actions">
        <button
          class="_toast-close"
          aria-label="Close Notification"
          {{on "click" @close}}
          data-test-notification-close
        >
          {{svgJar "heroicons-x-mark" width="24px" aria-hidden="true"}}
          Dismiss
        </button>
      </div>
    </aside>
  </template>
}
